import "./src/styles/index.scss"
import withContext from "./src/app/WrapRootElement";
import withAnimations from "./src/app/WrapPageElement";

export const wrapRootElement = withContext
export const wrapPageElement = withAnimations
